import { UseQueryResult, useQuery } from 'react-query'
import request from '../request'

type ReturnType = Array<{
  month: string
  open_amount: number
  invoice_amount: number
}>

export const useGetCustomerAgencyInvoiceHistory = ({
  agency_id,
}: {
  agency_id: number
}): UseQueryResult<{ data: ReturnType }, Error> => {
  return useQuery<
    {
      data: ReturnType
    },
    Error
  >(
    ['agencies', 'invoices', 'history'],
    ({ signal }) =>
      request({
        url: `/agencies/${agency_id}/invoices/history`,
        signal,
      }),
    { enabled: !!agency_id, keepPreviousData: true },
  )
}
